<div class="carousel">
  <div class="slides">
    <ng-container *ngFor="let slide of slides; let i = index">
      <app-image
        [src]="slide.url"
        [alt]="slide.text"
        *ngIf="i === slideInView"
        [@fadeInOut]
        class="slide"
        (swipeleft)="onNextClick()"
        (swiperight)="onPreviousClick()"
      >
      </app-image>
    </ng-container>
  </div>
</div>
<div class="thumbnails-wrapper" *ngIf="slides?.length > 1">
  <div class="thumbnails" #thumbnails>
    <ng-container *ngFor="let slide of slides; let i = index">
      <div
        class="thumbnail"
        (click)="onThumbnailClick(i)"
        (mouseover)="onMouseOver(i)"
        (mouseout)="onMouseOut()"
        [class.thumbnail--active]="activeSlide === i"
      >
        <app-image [src]="slide.url" [alt]="slide.text"> </app-image>
      </div>
    </ng-container>
  </div>
</div>

<div class="carousel-cta flex justify--center" *ngIf="slides?.length > 1">
  <button class="control control--prev" (click)="onPreviousClick()">
    <span class="icon icon-arrow-left icon-sm"></span>
  </button>
  <button class="control control--next" (click)="onNextClick()">
    <span class="icon icon-arrow-right icon-sm"></span>
  </button>
</div>
